module.exports = __webpack_public_path__ + "static/media/leadBundle1.8284b556.svg";